module.exports = __webpack_public_path__ + "static/media/viewIcon.47c5b4d7.svg";